var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "float": "left",
      "margin": "-40px 0 0 40px",
      "font-weight": "600"
    }
  }, [_vm._v("其他险种管理-详情")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "height": "40px",
      "margin-top": "-40px",
      "margin-right": "40px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    on: {
      "click": _vm.Return
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "750px",
      "background-color": "white",
      "margin": "75px 40px 0 40px",
      "padding": "100px",
      "overflow-x": "hidden"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#006E4B",
      "font-weight": "900",
      "font-size": "20px"
    }
  }, [_vm._v("|   ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "20px",
      "font-weight": "700"
    }
  }, [_vm._v("其他险种详情")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border": "1px solid #DADADA",
      "margin-top": "10px"
    }
  }), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "180px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-top": "80px",
      "width": "80%"
    },
    attrs: {
      "label": "保单名称",
      "prop": "name"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$parent.ruleForm.insurance_name) + "\n              ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-top": "80px",
      "width": "80%"
    },
    attrs: {
      "label": "投保账户",
      "prop": "name"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$parent.ruleForm.insure_account) + "\n              ")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "投保内容",
      "prop": "region"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$parent.ruleForm.dictionaries_id) + "\n                  ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "生效时间",
      "required": ""
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$parent.ruleForm.start_date) + " ~ " + _vm._s(_vm.$parent.ruleForm.end_date) + "\n              ")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "承保公司",
      "prop": "name"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$parent.ruleForm.company_name) + "\n              ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "单价",
      "prop": "name"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$parent.ruleForm.unit_price) + "\n              ")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "保单号",
      "prop": "name"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$parent.ruleForm.policy_no) + "\n              ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "保费",
      "prop": "name"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$parent.ruleForm.premium) + "\n              ")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "保额",
      "prop": "name"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$parent.ruleForm.insured_amount) + "\n              ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "免赔额、比例",
      "prop": "name"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$parent.ruleForm.proportion) + "\n              ")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "承保公司联系人",
      "prop": "name"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$parent.ruleForm.company_contacts) + "\n              ")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "备注",
      "prop": "name"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$parent.ruleForm.remarks) + "\n              ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "承保公司联系电话",
      "prop": "name"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$parent.ruleForm.company_telephone) + "\n              ")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "保单扫描件",
      "prop": "name"
    }
  }, [_c('img', {
    attrs: {
      "src": "$parent.ruleForm.insurance_url"
    }
  })])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "附件",
      "prop": "name"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$parent.ruleForm.enclosure_url) + "\n              ")])], 1)], 1)], 1)], 1)], 1)])
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b84b035e","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bxgl/QtxzGl/Qtxzgl_edit.vue
// module id = null
// module chunks = 